export const DEFAULT_CITY = 'new-york-city';

export const ROUTE_PATHS = {
  Home: '',
  Countdown: 'countdown',
  Question: 'question',
  Registration: 'registration',
  Result: 'result',
  // Disabled: the survey invite was removed from the active game flow.
  // SurveyInvite: 'survey-invite',
  SurveyQuestion: 'survey-question',
  Video: 'video',
} as const;

export const CITY_ROUTE = '/:city';

const withCity = (segment: string, options?: { city: string }) => {
  const city = options?.city || DEFAULT_CITY;
  return segment ? `/${city}/${segment}` : `/${city}`;
};

export const ROUTES = {
  Home: (options?: { city: string }) => withCity(ROUTE_PATHS.Home, options),
  Countdown: (options?: { city: string }) => withCity(ROUTE_PATHS.Countdown, options),
  Question: (options?: { city: string }) => withCity(ROUTE_PATHS.Question, options),
  Registration: (options?: { city: string }) => withCity(ROUTE_PATHS.Registration, options),
  Result: (options?: { city: string }) => withCity(ROUTE_PATHS.Result, options),
  // Disabled with the route above; restore both lines to re-enable the invite page.
  // SurveyInvite: (options?: { city: string }) => withCity(ROUTE_PATHS.SurveyInvite, options),
  SurveyQuestion: (options?: { city: string }) => withCity(ROUTE_PATHS.SurveyQuestion, options),
  Video: (options?: { city: string }) => withCity(ROUTE_PATHS.Video, options),
};
